import { Component, inject, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorStore } from '@state/error/error.store';
import { CnfpcButtonComponent } from '@shared/ui/cnfpc-button/cnfpc-button.component';

@Component({
  selector: 'app-error-modal',
  standalone: true,
  imports: [CommonModule, CnfpcButtonComponent],
  templateUrl: './error-modal.component.html',
  styleUrl: './error-modal.component.scss',
})
export class ErrorModalComponent {
  protected errorStore = inject(ErrorStore);

  // Click handler for the modal overlay
  onOverlayClick(event: MouseEvent) {
    // Close the modal only if the click is on the overlay
    this.errorStore.close();
  }

  close() {
    this.errorStore.close();
  }

  @HostListener('document:keydown.escape')
  onEscapeKeyPress() {
    if (this.errorStore.isOpen()) {
      this.errorStore.close();
    }
  }
}
